import * as React from 'react';
import { Alert } from '@payscale/design';

export class AccountAccessDeniedView extends React.Component {
    render(): React.ReactNode {
        return (
            <div className="container account-access-denied-container pxl-margin-top-lg">
                <Alert
                    level="warning"
                    message={this.renderUnauthorizedMessage()}
                    close={false}
                />
            </div>
        );
    }

    private renderUnauthorizedMessage(): React.ReactNode {
        return (
            <span>
                <b>You are not authorized to access this page.</b>
                <br />
                <span>Please contact your administrator.</span>
            </span>
        );
    }
}